var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { CloseIcon } from '../../icons/Close';
import { Background, Container, HeaderContainer, CloseIconContainer, } from './styles';
export var Modal = function (_a) {
    var children = _a.children, onExit = _a.onExit;
    var theme = useTheme();
    return (_jsx(Background, __assign({ onClick: function () { return onExit && onExit(); } }, { children: _jsxs(Container, __assign({ onClick: function (e) { return e.stopPropagation(); } }, { children: [onExit && (_jsx(HeaderContainer, { children: _jsx(CloseIconContainer, __assign({ onClick: function () { return onExit(); } }, { children: _jsx(CloseIcon, { color: theme.secondary }, void 0) }), void 0) }, void 0)), _jsx("div", { children: children }, void 0)] }), void 0) }), void 0));
};
